import { SaleOrderStatusEnum } from "@gtpl/shared-models/common-models";
import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { GrnDto } from "@gtpl/shared-models/procurement-management";
import { GrnItemsInfo } from "../../grn/dto/grn-items-info.model";
import { Stock } from "../stock.entity";
import { StockDto } from "./stock.dto";

export class StockAdapter {
    convertDtoToEntity(dtoObj: GrnItemsInfo,existingStockId:number,existingStockQty:number,locationId:number,unitId:number,soStatus:string,stockAcceptedQty:number,isInsertAndInsert?:boolean,isOnlyInsert?:boolean): Stock {
        try {
            console.log(dtoObj)
            // const stockItems : Stock[] = []
            const stockType = 'SaleOrder';
            const entityObj = new Stock();
            if (!dtoObj.stockId) {
                entityObj.createdUser = dtoObj.createdUser;
                entityObj.unitId = unitId;
                if(existingStockId > 0){
                    entityObj.physicalQuantity = Number(existingStockQty)+Number(stockAcceptedQty);
                }else{
                    entityObj.physicalQuantity = stockAcceptedQty;
                }
                entityObj.itemCategoryId = dtoObj.itemCategoryId;
                entityObj.itemSubCategoryId = dtoObj.itemSubCategoryId;
                if(soStatus == SaleOrderStatusEnum.CANCELLED ||(soStatus != SaleOrderStatusEnum.CANCELLED  && isOnlyInsert)){
                    entityObj.saleOrderId = 0;
                    
                }else{
                    entityObj.saleOrderId = dtoObj.saleOrderId;
                }
                entityObj.itemId = dtoObj.itemId;
                entityObj.sizeId = (dtoObj.sizeId)?(dtoObj.sizeId):0;
                entityObj.unitPrice = dtoObj.unitPrice;
                if(existingStockId > 0){

                entityObj.stockId = existingStockId;
                entityObj.updatedUser = 'Admin';
                }
                entityObj.locationId = locationId;
                // entityObj.minimumStock = 10000;
            }
            return entityObj;

        } catch (Error) {
            return Error;
        }
    }

    public convertEntityToDto(stockObj: Stock): StockDto {
        const stockDto = new Stock;
        stockDto.stockId = stockObj.stockId;
        stockDto.unitId = 1;
        stockDto.physicalQuantity = stockObj.physicalQuantity;
        stockDto.itemCategoryId = stockObj.itemCategoryId;
        stockDto.itemSubCategoryId = stockObj.itemSubCategoryId;
        stockDto.itemId = stockObj.itemId;
        stockDto.sizeId = stockObj.sizeId;
        stockDto.unitPrice = stockObj.unitPrice;
        // stockDto.locationId = 1;
        // stockDto.minimumStock = 10000;
        stockDto.createdAt = stockObj.createdAt;
        stockDto.updatedAt = stockObj.updatedAt;
        stockDto.createdUser = stockObj.createdUser;
        stockDto.updatedUser = stockObj.updatedUser;
        stockDto.versionFlag = stockObj.versionFlag;
        return stockDto;
    }
}